export enum Spacing {
  ConfiguratorDesktop = '195px',
}
